import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {Icon, Popover, PopoverInteractionKind, Position, Menu, MenuItem} from "@blueprintjs/core";
import { List } from "immutable";
import numeral from "numeral";

// Components
import VirtualizedTable from "../../../components/common/virtualized-table";

// Actions
import { getCostBreakdowns, cleanCostBreakdowns } from "../../../actions/cost-breakdowns";

// Numeral configuration
import 'numeral/locales/es-es'
numeral.locale('es-es');
numeral.defaultFormat('0,0.00 $');

const queryOptions = {
    projection: 'breakdown_code name comments customer statistics.total',
    populateRefs: [{
        field: 'customer',
        projection: 'basic_info.name'
    }],
    calculateStatistics: 'cost-breakdowns'
};

class CostBreakdownsPage extends Component {
    constructor(props) {
        super(props);

        this.state = {};
    }
    componentDidMount() {
        this.props.getCostBreakdowns(queryOptions);
    }
    componentWillUnmount() {
        this.props.cleanCostBreakdowns();
    }

    render() {
        let tableData = this.props.costBreakdowns;

        // Filters Zone
        let totalCostBreakdowns = 0;
        this.props.costBreakdowns.forEach(order => totalCostBreakdowns = totalCostBreakdowns + order.getIn(['statistics', 'total']));

        // CostBreakdowns Table
        let tableSettings = {
            showFooter: true,
            sortable: true,
            filterable: true,
            defaultSortFields: [],
            defaultSortDirections: ['asc'],
            height: tableData.size < 17 ? tableData.size * 40 : 680,
            rowHeight: 40,
            strippedRows: false
        };
        let tableColumns = {
            breakdown_code: {
                title: 'Código',
                columnType: 'function',
                dataField: ['_id', 'breakdown_code'],
                width: 100,
                style: {},
                sortable: true,
                sortableIndex: 1,
                filterable: true,
                filterableIndex: 1,
                nodeContent: (value) => {
                    return <Link to={ '/ventas/escandallos/' + value[0] }>{ value[1] }</Link>
                }
            },
            name: {
                title: "Nombre",
                columnType: 'text',
                dataField: 'name',
                width: 200,
                style: {},
                sortable: true,
                filterable: true,
            },
            comments: {
                title: "Comentarios",
                columnType: 'text',
                dataField: 'comments',
                width: 300,
                style: {},
                sortable: false,
                filterable: true,
            },
            customer: {
                title: "Cliente",
                columnType: 'text',
                dataField: 'customer',
                width: 200,
                style: {},
                sortable: true,
                filterable: true,
            },
            total: {
                title: "Total",
                columnType: 'number',
                dataField: 'statistics.total',
                width: 150,
                style: { textAlign: 'right' },
                sortable: false,
                filterable: true,
                footer: { type: 'operation', value: 'sum' }
            },
            actions: {
                title: '',
                columnType: 'function',
                dataField: '_id',
                width: 30,
                style: { alignItems: 'center', maxWidth: 30 },
                sortable: false,
                filterable: false,
                nodeContent: (value) => {
                    const popoverContent = (
                        <Menu>
                        <MenuItem icon="eye-open" text="Ver detalle" onClick={ () => this.props.history.push('/ventas/escandallos/' + value)} />
                    </Menu>
                    );

                    return (
                        <div>
                            <Popover
                                content={popoverContent}
                                interactionKind={PopoverInteractionKind.CLICK}
                                position={Position.LEFT_BOTTOM}
                            >
                                <Icon
                                    className="icon-custom"
                                    title={false}
                                    icon={'more'}
                                    iconSize={18}
                                    color="#183650"
                                />
                            </Popover>
                        </div>
                    );
                }
            }
        };

        return (
            <div id="page-wrapper" className="gray-bg">
                <div className="row wrapper border-bottom white-bg page-heading">
                    <div className="col d-flex align-items-center">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">
                                <Link to="/ventas/resumen">Ventas</Link>
                            </li>
                            <li className="breadcrumb-item active">
                                <strong>Escandallos</strong>
                            </li>
                        </ol>
                    </div>
                    <div className="col d-flex align-items-center justify-content-end">
                        <div className="title-action">
                            <button className="btn btn-primary" onClick={ () => this.props.history.push('/ventas/escandallos/nuevo') } > <Icon icon="insert"/>Escandallo</button>
                        </div>
                    </div>
                </div>
                <div className="wrapper wrapper-content">
                    <div className="row stats-zone" style={{ marginBottom: 20 }} >
                        <div className="col-auto">
                            <span className="label ">{ this.props.costBreakdowns.size || 0 }</span>
                            <span>Escandallos</span>
                        </div>
                        <div className="col-auto">
                            <span className="label ">{ numeral(totalCostBreakdowns).format() }</span>
                            <span>Importe Total </span>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">

                            <div className="ibox">
                                <div className="ibox-content">
                                    <VirtualizedTable
                                        tableSettings={tableSettings}
                                        tableColumns={tableColumns}
                                        tableData={tableData}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {

    // Reducers
    const costBreakdownsReducer = state.costBreakdowns;

    // CostBreakdowns
    let costBreakdowns = costBreakdownsReducer.get('payload') || List([]);

    if (!(costBreakdowns instanceof List)) {
        costBreakdowns = List([])
    }

    return {
        costBreakdowns
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getCostBreakdowns: (query) => dispatch(getCostBreakdowns(query)),
        cleanCostBreakdowns: () => dispatch(cleanCostBreakdowns())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(CostBreakdownsPage);


// WEBPACK FOOTER //
// ./src/containers/sales/cost-breakdowns/CostBreakdownsPage.js